import { cn } from "../../lib";
import { Box } from "../../primitives/box";
import { Icon } from "../icons";
import {
  radioButtonIndicatorVariants,
  radioButtonVariants,
  radioCheckTickSize,
} from "./radio-button.variants";
import type { RadioIndicatorProps } from "./types";

/**
 * RadioIndicator atom. The RadioButton's visual only: no press handling, no
 * focus, hidden from assistive technology. Use it inside a control that is
 * itself the radio — e.g. a `Card` with `accessibilityRole="radio"` — so the
 * card isn't a radio wrapped around a second radio.
 */
export const RadioIndicator = ({
  checked,
  disabled = false,
  size = "md",
  indicator = "fill",
  groupFocus = false,
  className,
  testID,
}: RadioIndicatorProps) => (
  <Box
    aria-hidden
    testID={testID}
    className={cn(
      radioButtonVariants({ size, indicator, checked, disabled, groupFocus }),
      className,
    )}
  >
    <Box className={radioButtonIndicatorVariants({ size, indicator, checked, disabled })}>
      {indicator === "check" && checked ? (
        <Icon name="Check" size={radioCheckTickSize[size]} color="brand-on-primary" weight="bold" />
      ) : null}
    </Box>
  </Box>
);

RadioIndicator.displayName = "RadioIndicator";
